import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
// Angular Imports
import { NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TabsModule } from 'ngx-bootstrap/tabs';
// This Module's Components
import { CheckinTicketNoComponent } from './checkin-ticket-no.component';

@NgModule({ declarations: [CheckinTicketNoComponent],
    exports: [CheckinTicketNoComponent], imports: [CommonModule,
        ModalModule.forRoot(),
        TabsModule.forRoot()], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class CheckinTicketNoModule {}
